module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-logo@3x__fba34ada8a157be1fc3fd624606f0984.png";